import { Platform } from 'react-native'

/**
 * Opens the chrome-free preview (DocletPreview in LinkingConfiguration) in a new
 * tab, so the builder stays open alongside it. The preview shows the saved
 * draft.
 */
const openDocletPreview = (docletId: string) => {
  if (Platform.OS !== 'web') return
  window.open(`/doclets/${encodeURIComponent(docletId)}/preview`, '_blank')
}

export default openDocletPreview
